module.exports = __webpack_public_path__ + "static/img/princeAlbert3.e8230ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/princeAlbert3.jpg
// module id = 125
// module chunks = 9